import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { KccButton } from 'lib/components/KccButton/KccButton';

export const Card = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    position: absolute;
    bottom: ${kcc.size.S200}px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: ${kcc.spacing.BASE};
    width: 368px;
    max-width: calc(100% - ${kcc.size.S400}px);
    padding: ${kcc.spacing.BASE};
    background-color: ${kcc.colors.WHITE};
    z-index: 2;
  `}
`;

export const Results = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
`;

export const RouteName = styled.p`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    margin: 0;
    font-size: ${kcc.typography.FONT_SIZE.BASE}px;
    font-weight: ${kcc.typography.FONT_WEIGHT.REGULAR};
    line-height: ${kcc.typography.LINE_HEIGHT.SM};
    color: ${kcc.colors.TEXT};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

export const MetricsRow = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    display: flex;
    align-items: center;
    gap: ${kcc.spacing.XS};
  `}
`;

export const TimeLeft = styled.p`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    margin: 0;
    font-size: ${kcc.typography.FONT_SIZE.BASE}px;
    font-weight: ${kcc.typography.FONT_WEIGHT.REGULAR};
    line-height: ${kcc.typography.LINE_HEIGHT.SM};
    color: ${kcc.colors.TEXT_PLACEHOLDER};
    white-space: nowrap;
  `}
`;

export const TimeRemaining = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  text-align: right;
  white-space: nowrap;
`;

export const TimeRemainingValue = styled.p`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    margin: 0;
    font-size: ${kcc.typography.FONT_SIZE.BASE}px;
    font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    line-height: ${kcc.typography.LINE_HEIGHT.SM};
    color: ${kcc.colors.TEXT};
  `}
`;

export const TimeRemainingLabel = styled.p`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    margin: 0;
    font-size: ${kcc.typography.FONT_SIZE.XS}px;
    font-weight: ${kcc.typography.FONT_WEIGHT.MEDIUM};
    line-height: ${kcc.typography.LINE_HEIGHT.BASE};
    color: ${kcc.colors.TEXT_SECONDARY};
  `}
`;

export const SkipButton = styled(KccButton).attrs({
  type: 'primary',
  shape: 'circle',
})`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    flex-shrink: 0;
    width: ${kcc.size.S500}px !important;
    height: ${kcc.size.S500}px !important;
    min-width: ${kcc.size.S500}px !important;

    /* arrowSkip SVG uses a hardcoded black fill */
    .ant-btn-icon svg path {
      fill: ${kcc.colors.PRIMARY_KARCHER};
    }

    /* A disabled button greys its content, so the icon follows it instead of staying yellow. */
    &:disabled .ant-btn-icon svg path,
    &.ant-btn-disabled .ant-btn-icon svg path {
      fill: currentColor;
    }

    /* The pending spinner is an open stroked arc, so the fills above must not reach it. Last, so it wins over them. */
    .ant-btn-icon [role='progressbar'] svg path {
      fill: none;
    }
  `}
`;
